const _ = require('lodash');

const eventDtmMapper = require('../dtm/common-mappers/event-analytics-mapper');
const errorDtmMapper = require('../dtm/common-mappers/error-analytics-mapper');

class AnalyticsService {
    constructor(gtmService, dtmService, settingsService, $log) {
        this.gtmService = gtmService;
        this.dtmService = dtmService;
        this.settingsService = settingsService;
        this.eventsDtm = dtmService.events;
        this.$log = $log;
    }

    push({ data = {}, gtmMapperFn = undefined, dtmMapperFn = undefined }) {
        if (gtmMapperFn && this.gtmService.isReadyToPush(data, gtmMapperFn, -1)) {
            this.gtmService.push(data, gtmMapperFn);
        }

        if (this.settingsService.settings && this.settingsService.settings.analytics && this.settingsService.settings.analytics.enableAdobeAnalytics && dtmMapperFn) {
            this.dtmService.push(data, dtmMapperFn);
        }
    }

    pushEvent(event) {
        this.push({ data: event, dtmMapperFn: eventDtmMapper });
    }

    pushError(error) {
        this.push({ data: error, dtmMapperFn: errorDtmMapper });
    }

    pushErrors(errors) {
        if (!errors) {
            this.$log.error('Truthy value is expected as the first argument of Analytics.pushErrors.');
            return;
        }

        if (!_.isArray(errors) || errors.length === 0) {
            this.$log.error('A populated array is expected as the first argument of Analytics.pushErrors.');
            return;
        }

        this.pushError(errors.join('|'));
    }
}

module.exports = AnalyticsService;



// WEBPACK FOOTER //
// ./src/olycommon/analytics/analytics/analytics.service.js